import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const CopyIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M3.33333 0.666748C2.6 0.666748 2 1.26675 2 2.00008V10.6667C2 11.0347 2.29867 11.3334 2.66667 11.3334C3.03467 11.3334 3.33333 11.0347 3.33333 10.6667V2.00008H10.6667C11.0347 2.00008 11.3333 1.70141 11.3333 1.33341C11.3333 0.965415 11.0347 0.666748 10.6667 0.666748H3.33333ZM6 3.33341C5.26667 3.33341 4.66667 3.93341 4.66667 4.66675V14.0001C4.66667 14.7334 5.26667 15.3334 6 15.3334H13.3333C14.0667 15.3334 14.6667 14.7334 14.6667 14.0001V7.21883C14.6667 6.8655 14.526 6.52612 14.276 6.27612L11.724 3.72404C11.474 3.47404 11.1346 3.33341 10.7812 3.33341H6ZM8 8.66675H11.3333C11.7013 8.66675 12 8.96542 12 9.33342C12 9.70142 11.7013 10.0001 11.3333 10.0001H8C7.632 10.0001 7.33333 9.70142 7.33333 9.33342C7.33333 8.96542 7.632 8.66675 8 8.66675ZM8 11.3334H11.3333C11.7013 11.3334 12 11.6321 12 12.0001C12 12.3681 11.7013 12.6667 11.3333 12.6667H8C7.632 12.6667 7.33333 12.3681 7.33333 12.0001C7.33333 11.6321 7.632 11.3334 8 11.3334Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

CopyIcon.propTypes = {
  sx: PropTypes.object,
};

export default CopyIcon;
